import React from 'react';
import Flex from 'components/common/Flex';
import LoginForm from './LoginForm';

const Login = () => (
  <>
    <Flex justifyContent="between" alignItems="center" className="mb-2">
      <h5>Prijava</h5>
      <p className="fs-10 text-600 mb-0">Seul WMS</p>
    </Flex>
    <LoginForm hasLabel />
  </>
);

export default Login;
